import BillItemPage, { MiniBillPage } from "../../../../pages/bill/BillItemPage";


export function BillPreview({ itemId }) {
    return <MiniBillPage pagePathParamsOverride={{ billId: itemId }} />
}